// EN CASO DE QUE SE AGREGUEN MAS CAMPOS OPCIONALES A DECISION ITEM

import { IProduct } from './Product';

export interface IExtraInformation {
  id: number,
  decision_item_id: number,
  extra_information: { [key: string]: any };
}

// SE DEBEN AGREGAR EN LA CONDICIÓN A LA FUNCIÓN decisionItemRecordIsComplete en DecisionTablePage
export interface IDecisionItem {
  id: number;
  tenant_id: number;
  tax_type_id: number;
  tax_number?: string;
  description?: string;
  description_type: number;
  distance?: number;
  product_id?: number;
  product?: IProduct;
  cost_center_id?: string;
  decision_item_extra_information?: IExtraInformation[];
}

export interface IDecisionItemCount {
  count: number;
}

export const StaticDecisionItemKeys = [
  "cost_center_id",
  "code",
  "description_type",
  "description",
  "distance",
  "product_description",
  "product_id",
  "product",
  "tax_number",
  "tax_type_id",
];